import React from 'react';

import {withRouter, WithRouterProps} from 'react-router';

import {
  procedureDetailSource,
  procedureVersionSource,
} from 'app/demo/demo_fixtures';
import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';

const procedure = procedureDetailSource;
const version = procedureVersionSource;

export const RedirectToProcedureVersionPage = withRouter<WithRouterProps>(
  ({router}: WithRouterProps) => {
    React.useEffect(() => {
      router.replace(
        `/demo/procedures/${procedure.hashid}/${procedure.slug}/version/${version.id}/`
      );
    }, []);
    return <DetailLoadingPage />;
  }
);
